import { useState } from "react";
import { motion } from "framer-motion";
import { Music, Play, Sparkles } from "lucide-react";
import { ASSETS, SPECIAL_VIDEOS, getSpecialArt, isSpecialFeatured } from "@/data/magicalContent";
import { MediaPlayerModal } from "@/components/magical/MediaPlayerModal";

export function SongSection() {
  const [activeSpecial, setActiveSpecial] = useState(null);
  return (
    <section id="songs" className="ns-section ns-songs" data-testid="songs-section">
      <motion.div className="ns-song-feature" initial={{ opacity: 0, y: 34 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <div className="ns-song-art"><img src={ASSETS.family} alt="Niyati and Shivu Season 1 song artwork" /><span><Music size={16} /> Official song</span></div>
        <div className="ns-song-copy">
          <p className="ns-kicker">Season 1 · Songs</p>
          <h2>Welcome to the<br /><em>magical world.</em></h2>
          <p>The official Niyati &amp; Shivu welcome song from Season 1, ready for little dreamers to sing along.</p>
          <audio data-testid="season-one-song-player" src="/official-song.mp3" controls preload="metadata" />
          <a className="ns-text-link" href="/season-1" data-testid="season-one-song-link"><Play size={15} /> Explore Season 1</a>
        </div>
      </motion.div>
      <div className="ns-specials-grid">
        {SPECIAL_VIDEOS.map((special) => (
          <motion.div className="ns-song-special" key={special.id} data-testid={`special-card-${special.id}`} initial={{ opacity: 0, y: 34 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <button type="button" className="ns-song-special-art" data-testid={`special-play-${special.id}`} onClick={() => setActiveSpecial(special)} aria-label={`Play ${special.title}`}>
              <img src={getSpecialArt(special)} alt={`${special.title} artwork`} loading="lazy" />
              {isSpecialFeatured(special) && <span className="ns-special-tag" data-testid={`special-featured-${special.id}`}>Featured this week</span>}
              <span className="ns-song-special-play"><Play size={26} fill="currentColor" /></span>
            </button>
            <div className="ns-song-copy">
              <p className="ns-kicker"><Sparkles size={14} /> {special.kicker}</p>
              <h2><em>{special.title}</em></h2>
              <p>{special.blurb}</p>
              <button type="button" className="ns-button ns-button-primary" data-testid={`special-cta-${special.id}`} onClick={() => setActiveSpecial(special)}><Play size={15} fill="currentColor" /> Play now</button>
            </div>
          </motion.div>
        ))}
      </div>
      {activeSpecial && <MediaPlayerModal kind="song" items={[{ episodeNumber: 0, label: activeSpecial.label, title: activeSpecial.title, youtubeId: activeSpecial.youtubeId, mediaKey: `special-${activeSpecial.id}` }]} startIndex={0} onClose={() => setActiveSpecial(null)} />}
    </section>
  );
}
